import React, { FC } from 'react';

export const CloseModal: FC = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m22.286 8.3-6.28 6.281L9.725 8.3 8.311 9.714l6.281 6.282L8.3 22.289l1.414 1.414 6.292-6.293 6.28 6.282 1.414-1.414-6.281-6.282L23.7 9.714 22.286 8.3Z"
      clipRule="evenodd"
    />
  </svg>
);
